import React from 'react';
import './css/MarqueeText.css';

const MarqueeText = () => {
  const text = "CRAFTING HOMES FOR MODERN LIVING";
  const repeatedText = new Array(10).fill(text);

  return (
    <div className="marquee-container">
      <div className="marquee-content">
        {repeatedText.map((item, index) => (
          <div key={index} className="marquee-item">
            <span className="dot"></span>
            <span className="text">{item}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MarqueeText;
